// Phase 2.7 — Pending NK/RR salary-approvals section extracted from
// MonthlyAccounting.jsx. Pure presentational; parent provides the rows +
// busy state + action callbacks. Hidden when there are no pending rows.

import { Section, Btn, Badge as _Badge } from "@/components/Shared";  // eslint-disable-line no-unused-vars
import { Pencil, CheckCircle2, X } from "lucide-react";
import { fmtINR, fmtPeriod } from "@/lib/api";

export default function PendingApprovalsTab({
  pendingApprovals,
  approvalBusy,
  onEdit, onApprove, onReject,
}) {
  if (!pendingApprovals.length) return null;
  return (
    <Section
      title={`Pending NK/RR salary approvals — ${pendingApprovals.length}`}
      testid="ma-pending-approvals"
    >
      <div className="p-3 text-[11.5px] text-amber-900 bg-amber-50 border-b border-amber-200">
        These tagged-person salary entries are <b>held</b> until approved. Each pending row triggered an approval email to the configured NK/RR address. Once approved, the amount auto-deducts from that partner's monthly payable.
      </div>
      <div className="overflow-x-auto">
        <table className="table-data w-full">
          <thead><tr>
            <th>Tag</th>
            <th>Person</th>
            <th>Month</th>
            <th className="text-right">Amount Paid</th>
            <th>Notes</th>
            <th className="text-right">Action</th>
          </tr></thead>
          <tbody>
            {pendingApprovals.map((p) => {
              const tone = p.person_tag === "NK"
                ? "bg-sky-50 text-sky-800 border-sky-200"
                : "bg-violet-50 text-violet-800 border-violet-200";
              return (
                <tr key={p.id} data-testid={`pending-${p.id}`}>
                  <td><span className={`inline-flex items-center px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider border rounded-sm ${tone}`}>{p.person_tag}</span></td>
                  <td className="font-medium">{p.person_name}<div className="text-[11px] text-[var(--muted)]">{p.person_for_from || "—"}</div></td>
                  <td className="num">{fmtPeriod(p.month)}</td>
                  <td className="text-right num font-semibold">₹ {fmtINR(p.amount_paid, 0)}</td>
                  <td className="text-[11px] text-[var(--muted)] max-w-xs truncate">{p.notes || "—"}</td>
                  <td className="text-right">
                    <button
                      onClick={() => onEdit(p)}
                      disabled={approvalBusy === p.id}
                      data-testid={`edit-pending-${p.id}`}
                      className="inline-flex items-center gap-1 px-2.5 h-9 text-[12px] font-medium rounded-sm border border-[var(--line-2)] hover:border-[var(--ink-2)] hover:bg-[var(--surface-2)] disabled:opacity-50"
                      title="Edit amount or notes before approving"
                    >
                      <Pencil size={12} /> Edit
                    </button>
                    <Btn variant="accent" testid={`approve-${p.id}`} onClick={() => onApprove(p.id)} disabled={approvalBusy === p.id} className="ml-2">
                      <CheckCircle2 size={12} /> Approve
                    </Btn>
                    <button
                      onClick={() => onReject(p.id)}
                      disabled={approvalBusy === p.id}
                      data-testid={`reject-${p.id}`}
                      className="ml-2 inline-flex items-center gap-1 px-3 h-9 text-[12px] font-medium rounded-sm border border-red-200 text-[var(--negative)] hover:bg-red-50 disabled:opacity-50"
                    >
                      <X size={12} /> Reject
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </Section>
  );
}
